import { render, staticRenderFns } from "./ModulesPainel.vue?vue&type=template&id=2cf3f306&scoped=true&"
import script from "./ModulesPainel.vue?vue&type=script&lang=js&"
export * from "./ModulesPainel.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=2cf3f306&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3f306",
  null
  
)

export default component.exports